// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__1MQN3","mainApp":"App_mainApp__26oop"};